<p-toast></p-toast>
<div class="full-screen">
  <div class="cabecera">
    <app-logout cabecera="Panel Administración Leads" style="width: 100%;"></app-logout>
  </div>
  <div class="tabla">
    <div style="height: 100%;">
      <app-menubar [opciones]="opciones_menu"></app-menubar>
    </div>
    <div style="overflow: auto;">
      <div class="boton-acciones">
        <p-splitButton 
        label="Seleccionar Opción" 
        [model]="items" 
        outlined 
        severity="danger" />
      </div>
      <app-tabla [filtersEnabled]="true" [data]="lista" [columns]="columnas" style="overflow: auto; height: 100%;">
        <ng-template pTemplate="kdHeaderStart" let-rowData>
          <th></th>
        </ng-template>
          <ng-template pTemplate="kdBodyStart" let-rowData>
            <td>
              <p-button type="button" icon="pi pi-pencil"  [rounded]="true" [outlined]="true" (click)="editar(rowData)"
              pTooltip="Editar Administrador" tooltipPosition="top"/>        
            </td>
          </ng-template>
      </app-tabla>
    </div>
  </div>
</div>

<p-dialog [(visible)]="ver_dialog" [modal]="true" [style]="{width: '50vw', height: '90vh'}" [draggable]="false">
    <app-formulario [formulario]="formulario" [data]="datos_formulario" (enviarFormulario)="onRecibirFormulario($event)"></app-formulario>
</p-dialog>
